const educationData = [
    {
        institution: 'Singidunum University, Belgrade',
        degree: 'Bachelor’s Degree in Management',
        description: 'Initially focused on management, I later discovered my true passion lay in software engineering—a field I’d long admired.',
        date: 'Graduated: 2015',
    },
    {
        institution: 'ITAcademy, Belgrade',
        degree: 'Certified Microsoft Engineer',
        description: 'Driven by my curiosity for how computers work, I enrolled in this intensive year-long program to build foundational skills in software engineering. My journey didn’t stop there; I invested countless hours in self-study, which remains an ongoing process through personal projects and continuous learning—shaping me into the dedicated software engineer I am today.',
        date: 'Completed: 2016',
    },
];

export default educationData;